import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {gsap} from "gsap";
import {TheBorder} from "../../TheBorder";
import {TheBorderGameMode} from "../../server/TheBorderGameMode";
import {TheBorderScatterSymbol} from "../../reels/TheBorderScatterSymbol";
import {TheBorderSymbol} from "../../reels/TheBorderSymbol";

/**
 * Created by Jerker Nord on 2021-01-28.
 */

export class TheBorderAvalancheBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        const tl: gsap.core.Timeline = gsap.timeline({onComplete: () => flowStateController.finish()});

        if (TheBorder.model.data.nextMode === TheBorderGameMode.NORMAL_AVALANCHE) {
            TheBorder.xRipButton.stopHighlightSparks();

            TheBorder.model.nearWinReels = [false, false, false, false, false, false];

            let allSymbols1stReel: TheBorderSymbol[] = (TheBorder.allReelsView.mainReelModels[0].reelView.getAllSymbols() as TheBorderSymbol[]),
                is1stReelEligible: boolean = false;

            if (TheBorder.model.isRestoreForNearWin) {
                is1stReelEligible = (TheBorder.allReelsView.mainReelModels[0].reelView.collapsedReel).length < 6;
            } else {
                for (let i: number = 0; i < allSymbols1stReel.length; i++) {
                    // keep it like this
                    if ((allSymbols1stReel[i].y as any) === "undefined") {
                        is1stReelEligible = true;
                        break;
                    }
                }
            }

            if (is1stReelEligible) {
                tl.add(() => {
                    const allScatterSymbols: TheBorderScatterSymbol[] = TheBorder.scatterSymbols.getAllUsedSymbols();
                    let scatterCount: number = 0,
                        scatterFoundOn1stReel: boolean = false;

                    allScatterSymbols.forEach((sym: TheBorderScatterSymbol) => {
                        scatterCount += sym.splitLevel;

                        if (sym.reelId === 0) {
                            scatterFoundOn1stReel = true;
                        }
                    });

                    if (scatterCount > 4 && !scatterFoundOn1stReel) {
                        TheBorder.reelHighlighter.highlightReel(0);
                        TheBorder.model.nearWinReels[0] = true;
                    }
                });
            }
        }

        if (tl.duration() == 0) {
            tl.add(gsap.to(this, {duration: 0.001}));
        }
    }
}